app.controller('analysisController', function ($scope, $rootScope, $routeParams, $location, $timeout, $window, $sce, $filter, safeApply, systemService, analysisService, storageService, apiService) {

  mapboxgl.accessToken = apiService.getMapboxAccessToken()
  const mapboxClient = mapboxSdk({ accessToken: 'pk.eyJ1IjoiZ2xlbm5nIiwiYSI6ImNpZmZ1ZnZqbjh5eGJzdWtua3Zib3M0c2gifQ.TcurCtii8i7e3w7oo1WW5Q' })

  $scope.analysisControllerInit = false
  $scope.showNavigationDropdown = true
  $scope.showCompTray = false
  $scope.showEUMapOverlay = false

  const route_params = $routeParams
  const element = document.getElementById('shareButtons')

  // Top level navigation (Jump to section) ---------------------------------------------------------------
  $scope.navigation = [
    { name: 'Top of Analysis', link: 'top' },
    { name: 'Our Approach', link: 'our_approach' },
    { name: 'Subject Property Analysis', link: 'subject_prop_analysis' },
    { name: 'Homestead Cap Analysis', link: 'homestead_cap_analysis' },
    { name: 'Market Analysis Section', link: 'market_section' },
    { name: 'Equal & Uniform Analysis Section', link: 'eu_section' },
    { name: 'Property Condition Analysis', link: 'condition_section' },
    { name: 'Protest Strategy', link: 'protest_stategy' },
    { name: 'User Feedback', link: 'user_feedback_section' },
  ]

  // Options for displaying comparable properties in dropdown - for chart
  $scope.compOptions = [
    { label: "Square Footage", subLabel: "", key: "sqft", sortField: "sqft", sortOrder: "asc" },
    { label: "Land Market Value", subLabel: "", key: "land_market_value", sortField: "land_market_value", sortOrder: "asc" },
    { label: "Quality Rating", subLabel: "", key: "quality", sortField: "quality", sortOrder: "asc" },
  ]
  $scope.selectedCompKey = "sqft"

  // marketCompChart Combo Box -----------------------------------------------------------------------------
  $scope.setMarketCompChart = (metric) => {
    $scope.selectedCompKey = metric
    initMarketCompChart()
  }
  $scope.getDisplayTextCompChart = function () {
    let selectedOption = $scope.compOptions.find(option => option.key === $scope.selectedCompKey)
    return selectedOption ? selectedOption.label + " " + selectedOption.subLabel : "Select Sorting"
  }
  // END: marketCompChart Combo Box -------------------------------------------------------------------------

  $scope.euMapOptions = [
    { key: "sqft", label: "Percent Change", subLabel: "", sortField: "sqft", sortOrder: "asc" },
    { key: "land_market_value", label: "Value / Square Foot", subLabel: "", sortField: "land_market_value", sortOrder: "asc" },
    { key: "quality", label: "Percent Match", subLabel: "", sortField: "quality", sortOrder: "asc" },
  ]
  $scope.selectedEuMapKey = "sqft"
  // marketCompChart Combo Box -----------------------------------------------------------------------------
  $scope.setEuMap = (metric) => {
    $scope.selectedEuMapKey = metric
    initEqualUniformMap()
  }
  $scope.getDisplayTextEuMap = function () {
    let selectedOption = $scope.euMapOptions.find(option => option.key === $scope.selectedEuMapKey)
    return selectedOption ? selectedOption.label + " " + selectedOption.subLabel : "Select Sorting"
  }
  // END: marketCompChart Combo Box -------------------------------------------------------------------------

  // Sort options for displaying comparable properties in dropdown
  $scope.sortOptions = [
    { key: "mv_comps_sort_distance_near", label: "Distance", subLabel: "(Nearest to Subject)", sortField: "distance_miles", sortOrder: "asc" },
    { key: "mv_comps_sort_distance_far", label: "Distance", subLabel: "(Farthest from Subject)", sortField: "distance_miles", sortOrder: "desc" },
    { divider: true },
    { key: "mv_comps_sort_close_recent", label: "Close Date", subLabel: "(Most Recent)", sortField: "close_date", sortOrder: "desc" },
    { key: "mv_comps_sort_close_oldest", label: "Close Date", subLabel: "(Oldest)", sortField: "close_date", sortOrder: "asc" },
    { divider: true },
    { key: "mv_comps_sort_sqft_small_large", label: "Square Footage", subLabel: "(Small -> Large)", sortField: "sqft", sortOrder: "asc" },
    { key: "mv_comps_sort_sqft_large_small", label: "Square Footage", subLabel: "(Large -> Small)", sortField: "sqft", sortOrder: "desc" },
    { divider: true },
    { key: "mv_comps_sort_score_most_similar", label: "% Match", subLabel: "(Most Similar)", sortField: "total_score", sortOrder: "desc" },
    { key: "mv_comps_sort_score_least_similar", label: "% Match", subLabel: "(Least Similar)", sortField: "total_score", sortOrder: "asc" }
  ]
  $scope.selectedSortKey = "mv_comps_sort_score_most_similar"

  $scope.showAll = false
  $scope.uid = route_params.uid
  $scope.route = 'analysis'
  $scope.analysisRunning = true
  $scope.shareSectionVisible = false
  $scope.feedbackFormVisible = false
  $scope.feedbackType = ''
  $scope.feedbackDetails = ''

  toastr.options = {
    "closeButton": false,
    "debug": false,
    "newestOnTop": false,
    "progressBar": false,
    "positionClass": "toast-bottom-right",
    "preventDuplicates": false,
    "onclick": null,
    "showDuration": "300",
    "hideDuration": "1000",
    "timeOut": "5000",
    "extendedTimeOut": "1000",
    "showEasing": "swing",
    "hideEasing": "linear",
    "showMethod": "fadeIn",
    "hideMethod": "fadeOut"
  }

  initController()
  // START: initController -----------------------------------------------------------------------------------
  async function initController() {
    if (route_params.uid == null || route_params.uid == undefined) { systemService.route_change('/') }

    const cad_code = $scope.uid.substring(0, 3)
    const cad_account = $scope.uid.substring(3)

    let analysisResults = await systemService.functionCall({ type: 'mainAnalysis', cad_code: cad_code, cad_account: cad_account, caller: "index", user_id: 0 })

    if (analysisResults.data.success) {
      $scope.analysisRunning = false
      $scope.data = analysisResults.data.data

      // Remove the HS CAP jump to section if the property is not homesteaded
      if ($scope.data.homesteadCap.show == false) {
        $scope.navigation = $scope.navigation.filter(item => item.name !== 'Homestead Cap Analysis')
      }

      // --- For Testing Purposes Only ---------------------------------------
      // $scope.data.alreadySignedUp = false
      // $scope.data.caller = 'index'  // 'dashboard' | 'index'
      // ---------------------------------------------------------------------

      if ($scope.data.caller == 'dashboard') {
        $scope.sortOptions.push(
          { divider: true },
          { key: "mv_comps_sort_sellprice_small_large", label: "Sell Price", subLabel: "(Lowest to Highest Sales Price)", sortField: "close_price", sortOrder: "asc" },
          { key: "mv_comps_sort_sellprice_large_small", label: "Sell Price", subLabel: "(Highest to Lowest Sales Price)", sortField: "close_price", sortOrder: "desc" }
        )
        $scope.compOptions.push(
          { key: "close_price", label: "Close Price", subLabel: "(Lowest to Highest)", sortField: "close_price", sortOrder: "asc" }
        )
      }

      console.log('$scope.data :>> ', $scope.data);
      // console.log('$scope.data.marketAnalysis.comps[0] :>> ', JSON.stringify($scope.data.marketAnalysis.comps[0], null, 2));

      setTimeout(() => {
        initMarketMap()
        initMarketCompChart()
        initMarketRadarChart()
        initEqualUniformMap()
        initEqualUniformRadarChart()
        initComponents()
      }, 0)

      $scope.analysisControllerInit = true
      safeApply($scope)

      // setTimeout(() => {
      //   $scope.scrollTo('euMapScrollTop', 40)
      // }, 0)

    }
  }
  // END: initController -----------------------------------------------------------------------------------

  // Market Analysis (Recent Sales Map) --------------------------------------------------------------------
  function initMarketMap() {
    const map = new mapboxgl.Map({
      container: 'mapMarket',
      style: 'mapbox://styles/glenng/clb5jetvv001015rs0i0qwd7c',
      center: [$scope.data.subjectProperty.longitude, $scope.data.subjectProperty.latitude],
      pitch: 60,
      bearing: -60,
      zoom: 16,
      minZoom: 14,
      maxZoom: 17
    })
    const bounds = new mapboxgl.LngLatBounds();
    const subjectMarker = new mapboxgl.Marker({ color: '#ff0000' })
      .setLngLat([$scope.data.subjectProperty.longitude, $scope.data.subjectProperty.latitude])
      .addTo(map)
    bounds.extend([$scope.data.subjectProperty.longitude, $scope.data.subjectProperty.latitude])
    $scope.data.marketAnalysis.comps.forEach(comp => {
      let closePriceInfo
      if ($scope.data.caller == 'dashboard') {
        closePriceInfo = `$${comp.close_price.toLocaleString()}`
      } else if ($scope.data.caller == 'index') {
        closePriceInfo = `<span style="color: red; font-weight: bold;">Sign Up for Free to Access</span>`
      }
      const popupContent = `
            <div style="height: 12px;"></div>
            <strong class="text-center" style="padding-top: 20px;">${comp.address}</strong><br>
            <strong>Close Date:</strong> ${formatDate(comp.close_date)}<br>
            <strong>Sqft:</strong> ${Number(comp.sqft).toLocaleString()}<br>
            <strong>Close Price:</strong> ${closePriceInfo}`
      const marker = new mapboxgl.Marker({ color: '#0066ff' })
        .setLngLat([comp.lng, comp.lat])
        .setPopup(new mapboxgl.Popup({ offset: 25 }).setHTML(popupContent))
        .addTo(map)
      bounds.extend([comp.lng, comp.lat])
    })
    map.fitBounds(bounds, {
      padding: 50,
      maxZoom: 16
    })
    map.addControl(new mapboxgl.NavigationControl());
    map.addControl(new mapboxgl.FullscreenControl());
    map.addControl(new mapboxgl.ScaleControl({
      maxWidth: 80,
      unit: 'metric'
    }))
  }
  // End Market Analysis (Recent Sales Map) ----------------------------------------------------------------

  // Market Analysis (Comparable Properties Chart) ---------------------------------------------------------
  function initMarketCompChart() {
    let comps = angular.copy($scope.data.marketAnalysis.comps)
    comps.forEach(comp => { comp.type = 'comp' })
    comps.push({
      address: $scope.data.subjectProperty.address,
      sqft: $scope.data.subjectProperty.squareFeet,
      close_price: $scope.data.subjectProperty.value,
      land_market_value: $scope.data.subjectProperty.landMarketValue,
      type: 'subject'
    })
    let sortedComps = comps.sort((a, b) => a[$scope.selectedCompKey] - b[$scope.selectedCompKey])
    let values = sortedComps.map(comp => comp[$scope.selectedCompKey])
    let addresses = sortedComps.map(comp => comp.address);
    let backgroundColors = sortedComps.map(comp => comp.type === 'subject' ? 'rgba(255, 0, 0, 0.6)' : 'rgba(54, 162, 235, 0.6)')
    let borderColors = sortedComps.map(comp => comp.type === 'subject' ? 'rgba(255, 0, 0, 1)' : 'rgba(54, 162, 235, 1)')

    if ($scope.chartInstance) $scope.chartInstance.destroy()
    let ctx = document.getElementById('marketCompChart').getContext('2d')
    const selectedLabel = $scope.compOptions.find(option => option.key === $scope.selectedCompKey)?.label || "Label Not Found"

    $scope.chartInstance = new Chart(ctx, {
      type: 'bar',
      data: {
        labels: Array(values.length).fill(''),
        datasets: [
          {
            label: 'Comps',
            data: values,
            backgroundColor: backgroundColors,
            borderColor: borderColors,
            borderWidth: 1
          },
          {
            label: 'Subject Property',
            data: values,
            type: 'line',
            borderColor: 'rgba(255, 99, 132, .5)',
            borderWidth: 2,
            fill: false,
            pointRadius: 0
          }
        ]
      },
      options: {
        scales: {
          x: {
            display: false
          },
          y: {
            beginAtZero: true
          }
        },
        plugins: {
          tooltip: {
            callbacks: {
              label: function (tooltipItem) {
                return [
                  addresses[tooltipItem.dataIndex], // First line: Address
                  selectedLabel + ": " + Number(tooltipItem.raw).toLocaleString() // Second line: Formatted value
                ];
              }
            }
          },
          legend: {
            display: true,
            position: 'bottom',
            labels: {
              usePointStyle: false,
              generateLabels: function (chart) {
                return [
                  {
                    text: 'Comps',
                    fillStyle: 'rgba(54, 162, 235, 0.6)',
                    strokeStyle: 'rgba(54, 162, 235, 1)',
                    hidden: false
                  },
                  {
                    text: 'Subject Property',
                    fillStyle: 'rgba(255, 0, 0, 0.6)',
                    strokeStyle: 'rgba(255, 0, 0, 1)',
                    hidden: false
                  }
                ];
              }
            }
          }
        }
      }
    });
  }
  // End Market Analysis (Comparable Properties Chart) -----------------------------------------------------

  // Market Analysis (Radar Chart - Property Features Comparison) ------------------------------------------
  function initMarketRadarChart() {
    const featuresRadarCtx = document.getElementById('featuresRadarChart').getContext('2d');
    const featuresRadarChart = new Chart(featuresRadarCtx, {
      type: 'radar',
      data: {
        labels: $scope.data.marketAnalysis.radarChartData.labels,
        datasets: [
          {
            label: 'Subject Property',
            data: $scope.data.marketAnalysis.radarChartData.subjectValues,
            fill: true,
            backgroundColor: 'rgba(255, 99, 132, 0.2)',
            borderColor: 'rgb(255, 99, 132)',
            pointBackgroundColor: 'rgb(255, 99, 132)',
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: 'rgb(255, 99, 132)'
          },
          {
            label: 'Area Average',
            data: [50, 50, 50, 50, 50, 50],
            fill: true,
            backgroundColor: 'rgba(54, 162, 235, 0.2)',
            borderColor: 'rgb(54, 162, 235)',
            pointBackgroundColor: 'rgb(54, 162, 235)',
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: 'rgb(54, 162, 235)'
          }
        ]
      },
      options: {
        responsive: true,  // Makes the chart responsive
        elements: {
          line: {
            borderWidth: 3
          }
        },
        scales: {
          r: {
            angleLines: {
              display: true
            },
            suggestedMin: 0,
            suggestedMax: 100,
            pointLabels: {
              font: {
                size: 12
              }
            }
          }
        },
        plugins: {
          tooltip: {
            callbacks: {
              title: function (tooltipItems) {
                // Extract just the attribute name without the percentile info
                const fullLabel = tooltipItems[0].label;
                const attributeName = fullLabel.split(' (')[0];
                return attributeName;
              },
              label: function (context) {
                const labelMap = {
                  'Size (Top 40%)': 'Your property is larger than 60% of homes',
                  'Building Class (Top 30%)': 'Your building class exceeds 70% of properties',
                  'Condition (Top 20%)': 'Your condition is better than 80% of properties',
                  'Lot Size (Top 55%)': 'Your lot is below average for the area',
                  'Age (Top 25%)': 'Your property is newer than 75% of homes',
                  'Additional Improvements (Top 25%)': 'Your improvements exceed 75% of properties'
                };

                let label = context.dataset.label || '';
                if (label) {
                  label += ': ';
                }
                if (context.parsed.r !== null) {
                  label += context.parsed.r;

                  // Add descriptive text for subject property
                  if (context.dataset.label === 'Subject Property') {
                    const fullLabel = context.chart.data.labels[context.dataIndex];
                    if (labelMap[fullLabel]) {
                      label += ` (${labelMap[fullLabel]})`;
                    }
                  }
                }
                return label;
              }
            }
          }
        }
      }
    })
  }
  // End Market Analysis (Radar Chart - Property Features Comparison) --------------------------------------

  // Start: Equal & Uniform (Radar Chart - Property Features Comparison) -----------------------------------
  function initEqualUniformRadarChart() {
    const featuresRadarCtxEU = document.getElementById('featuresRadarChartEU').getContext('2d');
    const featuresRadarChartEU = new Chart(featuresRadarCtxEU, {
      type: 'radar',
      data: {
        labels: $scope.data.euAnalysis.radarChartData.labels,
        datasets: [
          {
            label: 'Subject Property',
            data: $scope.data.euAnalysis.radarChartData.subjectValues,
            fill: true,
            backgroundColor: 'rgba(255, 99, 132, 0.2)',
            borderColor: 'rgb(255, 99, 132)',
            pointBackgroundColor: 'rgb(255, 99, 132)',
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: 'rgb(255, 99, 132)'
          },
          {
            label: 'Area Average',
            data: [50, 50, 50, 50, 50, 50],
            fill: true,
            backgroundColor: 'rgba(54, 162, 235, 0.2)',
            borderColor: 'rgb(54, 162, 235)',
            pointBackgroundColor: 'rgb(54, 162, 235)',
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: 'rgb(54, 162, 235)'
          }
        ]
      },
      options: {
        elements: {
          line: {
            borderWidth: 3
          }
        },
        scales: {
          r: {
            angleLines: {
              display: true
            },
            suggestedMin: 0,
            suggestedMax: 100
          }
        }
      }
    })
  }
  // End: Equal & Uniform (Radar Chart - Property Features Comparison) -------------------------------------


  // Start: Equal & Uniform Analysis (Map) -----------------------------------------------------------------
  function initEqualUniformMap() {
    const map = new mapboxgl.Map({
      container: 'mapEU',
      style: 'mapbox://styles/glenng/clb5jetvv001015rs0i0qwd7c',
      center: [$scope.data.subjectProperty.longitude, $scope.data.subjectProperty.latitude],
      zoom: 16,
      minZoom: 14,
      maxZoom: 17
    })
    const parcelIds = []
    $scope.data.euAnalysis.comps.forEach(comp => {
      parcelIds.push(comp.cad_account)
    })
    map.addControl(new mapboxgl.NavigationControl())
    map.addControl(new mapboxgl.ScaleControl({
      maxWidth: 80,
      unit: 'metric'
    }))
    map.on('load', async () => {
      const layerKey = 'parcel_id';
      map.addSource('comps', {
        type: 'vector',
        url: 'mapbox://glenng.a1g4zj1h'
      })
      let propsLayer = {
        id: 'props',
        type: 'fill',
        source: 'comps',
        'source-layer': `c_${$scope.data.subjectProperty.cad_code}_parcels`,
        filter: ['in', ['get', `${layerKey}`], ['literal', parcelIds]],
        paint: {
          'fill-color': 'rgba(0, 0, 0, 0)',
          'fill-outline-color': 'rgb(0, 255, 17)'
        }
      }
      let subjLayer = {
        id: 'subject',
        type: 'fill',
        source: 'comps',
        'source-layer': `c_${$scope.data.subjectProperty.cad_code}_parcels`,
        filter: ['==', `${layerKey}`, $scope.data.subjectProperty.cad_account],
        paint: {
          'fill-color': 'rgb(0, 255, 115)',
          'fill-outline-color': 'rgb(0, 255, 17)',
          // "line-color": '#89FA87',
          // "line-width": 3
        }
      }
      map.addLayer(propsLayer)
      map.addLayer(subjLayer)
      let currSelection
      map.on('click', 'props', async (e) => {
        console.log('clicked')
        let parcelId = e.features[0].properties[layerKey] //ParcelID
        console.log('parcelId', parcelId)
        let mapLayer = map.getLayer('comp-selected')
        if (parcelId == currSelection) {
          map.removeLayer('comp-selected')
          currSelection = undefined
          $scope.showCompTray = false
          safeApply($scope)
        } else if (parcelId == $scope.data.subjectProperty.cad_account) {
          console.log('subject parcel was selected')
          $scope.showCompTray = false
          safeApply($scope)
        } else if (parcelId != currSelection && parcelId != $scope.data.subjectProperty.cad_account) {
          $scope.showCompTray = false
          currSelection = parcelId
          if (typeof mapLayer != 'undefined') map.removeLayer('comp-selected')
          map.addLayer({
            id: 'comp-selected',
            type: 'fill',
            source: 'comps',
            'source-layer': `c_${$scope.data.subjectProperty.cad_code}_parcels`,
            // filter: ['in', ['get','ParcelID'], ['literal',parcelId]],
            filter: ['==', `${layerKey}`, parcelId],
            paint: {
              'fill-color': 'rgb(61, 87, 255)',
              'fill-outline-color': 'rgb(113, 118, 250)',
              // "line-color": 'yellow',
              // "line-width": 2
            }
          })
          $scope.showEUMapOverlay = true
          let analysisResults = await systemService.functionCall({ type: 'sideBySideAnalysis', cadCode: $scope.data.subjectProperty.cad_code, subjCadAccount: $scope.data.subjectProperty.cad_account, compCadAccount: parcelId, compType: "EU" })
          // console.log('analysisResults :>> ', analysisResults);
          // console.log('analysisResults :>> ', JSON.stringify(analysisResults.data.data.sideBySide, null, 2));
          $scope.compData = analysisResults.data.data
          $scope.showEUMapOverlay = false
          $scope.showCompTray = true
          safeApply($scope)
        } else {
          $scope.showCompTray = false
          safeApply($scope)
        }
      })
    })
  }
  // End: Equal & Uniform Analysis (Map) -------------------------------------------------------------------

  $scope.animateTray = function () {
    if ($scope.showCompTray) {
      $scope.showCompTray = false
      safeApply($scope)
      setTimeout(function () {
        $scope.$apply(function () {
          $scope.showCompTray = true
        })
      }, 400)
    } else {
      $scope.showCompTray = true
      safeApply($scope)
    }
  }

  $scope.buttonManager = async (button) => {
    let uid
    switch (button) {
      case 'export_report':
        printPage()
        break
      case 'share':
        $scope.shareButtons = bootstrap.Dropdown.getOrCreateInstance(element)
        $scope.shareButtons.toggle()
        break
      case 'sign_up':
        uid = route_params.uid;
        register_route = `https://dashboard.propertytax.io/signup/${uid.substring(0, 3)}/${uid.substring(3)}`
        $window.location = register_route
        break
      case 'sign_in':
        uid = route_params.uid;
        register_route = `https://dashboard.propertytax.io/signin`
        $window.location = register_route
        break
      case 'thumbs_up':
        $scope.shareSectionVisible = true
        $scope.feedbackFormVisible = false
        safeApply($scope)
        break
      case 'thumbs_down':
        $scope.feedbackFormVisible = true
        $scope.shareSectionVisible = false
        safeApply($scope)
        break
      case 'copy_link':
        navigator.clipboard.writeText("https://propertytax.io")
        break
      case 'submit_feedback':
        console.log('$scope.feedbackType :>> ', $scope.feedbackType)
        console.log('$scope.feedbackDetails :>> ', $scope.feedbackDetails)
        const feedback = {
          type: $scope.feedbackType,
          details: $scope.feedbackDetails,
          cad_code: $scope.uid.substring(0, 3),
          cad_account: $scope.uid.substring(3)
        }
        const submitFeedbackResults = await systemService.functionCall({ type: 'submitFeedback', data: feedback })
        if (submitFeedbackResults.data.success) {
          toastr.success("Feedback was submitted to PropertyTax.io Management!", "Feedback Sent", 15000)
        } else {
          toastr.error("There was an error submitting your feedback, please feel free to chat in with us!", "Feedback Submit Error", 10000)
        }
        $scope.feedbackType = ''
        $scope.feedbackDetails = ''
        $scope.shareSectionVisible = false
        $scope.feedbackFormVisible = false
        safeApply($scope)
        break
    }
  }

  function formatDate(date) {
    return $filter('date')(date, 'MM/dd/yyyy')
  }

  function printPage() {
    setTimeout(function () {
      const isChromium = !!window.chrome
      if (isChromium) {
        const printOptions = {
          printBackground: true,
          preferCSSPageSize: true
        }
        window.print(printOptions)
      } else {
        window.print()
      }
    }, 800)
  }

  $scope.scrollTo = function (id, headerOffset) {
    $timeout(function () {
      var element = document.getElementById(id)
      if (element) {
        // var headerOffset = 125
        var elementPosition = element.getBoundingClientRect().top + window.scrollY
        var offsetPosition = elementPosition - headerOffset
        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth"
        })
      }
    }, 0)
  }


  // Sort Comps in Market Analysis (Comparable Properties)---------------------------------------------------
  $scope.getDisplayTextCompList = function () {
    let selectedOption = $scope.sortOptions.find(option => option.key === $scope.selectedSortKey)
    return selectedOption ? selectedOption.label + " " + selectedOption.subLabel : "Select Sorting"
  }
  $scope.marketCompSortMethod = (sortKey) => {
    $scope.selectedSortKey = sortKey
    let selectedOptionSort = $scope.sortOptions.find(option => option.key === $scope.selectedSortKey)
    sortComps(selectedOptionSort.sortField, selectedOptionSort.sortOrder)
    safeApply($scope)
  }
  function sortComps(field, order = 'asc') {
    const comps = $scope.data.marketAnalysis.comps
    const isAscending = order === 'asc'
    comps.sort((a, b) => {
      let valueA = a[field]
      let valueB = b[field]
      if (field === 'close_date') {
        valueA = valueA ? new Date(valueA).getTime() : 0
        valueB = valueB ? new Date(valueB).getTime() : 0
      } else {
        if (!isNaN(valueA) && valueA !== null) valueA = Number(valueA)
        if (!isNaN(valueB) && valueB !== null) valueB = Number(valueB)
      }
      if (typeof valueA === 'string' && typeof valueB === 'string') {
        return isAscending ? valueA.localeCompare(valueB) : valueB.localeCompare(valueA)
      }
      return isAscending ? valueA - valueB : valueB - valueA
    })
  }
  // End Sort Comps in Market Analysis (Comparable Properties)---------------------------------------------------

  $scope.toggleComps = function () {
    $scope.showAll = !$scope.showAll
  }

  $scope.returnToHome = () => {
    systemService.route_change('home')
  }

  // *************************************************************************
  // Leave this at the bottom - do not put any functions below this section **
  // *************************************************************************
  function initComponents() {
    feather.replace()

    //Menu
    // Toggle menu
    $scope.toggleMenu = () => {
      document.getElementById('isToggle').classList.toggle('open')
      var isOpen = document.getElementById('navigation')
      if (isOpen.style.display === "block") {
        isOpen.style.display = "none"
      } else {
        isOpen.style.display = "block"
      }
    }

    //Menu Active
    function getClosest(elem, selector) {

      // Element.matches() polyfill
      if (!Element.prototype.matches) {
        Element.prototype.matches =
          Element.prototype.matchesSelector ||
          Element.prototype.mozMatchesSelector ||
          Element.prototype.msMatchesSelector ||
          Element.prototype.oMatchesSelector ||
          Element.prototype.webkitMatchesSelector ||
          function (s) {
            var matches = (this.document || this.ownerDocument).querySelectorAll(s),
              i = matches.length;
            while (--i >= 0 && matches.item(i) !== this) { }
            return i > -1;
          };
      }

      // Get the closest matching element
      for (; elem && elem !== document; elem = elem.parentNode) {
        if (elem.matches(selector)) return elem;
      }
      return null;

    };

    function activateMenu() {
      var menuItems = document.getElementsByClassName("sub-menu-item");
      if (menuItems) {

        var matchingMenuItem = null;
        for (var idx = 0; idx < menuItems.length; idx++) {
          if (menuItems[idx].href === window.location.href) {
            matchingMenuItem = menuItems[idx];
          }
        }

        if (matchingMenuItem) {
          matchingMenuItem.classList.add('active');
          var immediateParent = getClosest(matchingMenuItem, 'li');
          if (immediateParent) {
            immediateParent.classList.add('active');
          }

          var parent = getClosest(matchingMenuItem, '.parent-menu-item');
          if (parent) {
            parent.classList.add('active');
            var parentMenuitem = parent.querySelector('.menu-item');
            if (parentMenuitem) {
              parentMenuitem.classList.add('active');
            }
            var parentOfParent = getClosest(parent, '.parent-parent-menu-item');
            if (parentOfParent) {
              parentOfParent.classList.add('active');
            }
          } else {
            var parentOfParent = getClosest(matchingMenuItem, '.parent-parent-menu-item');
            if (parentOfParent) {
              parentOfParent.classList.add('active');
            }
          }
        }
      }
    }

    // Clickable Menu
    if (document.getElementById("navigation")) {
      var elements = document.getElementById("navigation").getElementsByTagName("a");
      for (var i = 0, len = elements.length; i < len; i++) {
        elements[i].onclick = function (elem) {
          if (elem.target.getAttribute("href") === "javascript:void(0)") {
            var submenu = elem.target.nextElementSibling.nextElementSibling;
            submenu.classList.toggle('open');
          }
        }
      }
    }

    // Menu sticky
    function windowScroll() {
      const navbar = document.getElementById("topnav");
      if (navbar != null) {
        if (
          document.body.scrollTop >= 50 ||
          document.documentElement.scrollTop >= 50
        ) {
          navbar.classList.add("nav-sticky");
        } else {
          navbar.classList.remove("nav-sticky");
        }
      }
    }

    window.addEventListener('scroll', (ev) => {
      ev.preventDefault();
      windowScroll();
    })

    // back-to-top
    var mybutton = document.getElementById("back-to-top");
    window.onscroll = function () {
      scrollFunction();
    }

    function scrollFunction() {
      if (mybutton != null) {
        if (document.body.scrollTop > 500 || document.documentElement.scrollTop > 500) {
          mybutton.style.display = "block"
        } else {
          mybutton.style.display = "none"
        }
      }
    }

    $scope.topFunction = () => {
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
    }

  }

})